





















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { MasterModule } from '@/app/store/modules/master'

@Component({
  name: 'FilterChart',
  components: {
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) private isDisabled: boolean | undefined
  @Prop({}) private funcFilter: any | undefined
  @Prop({}) private funcClearFilter: any | undefined
  @Prop({}) private hasFilter: boolean | undefined
  @Prop({}) private onClearFilter: boolean | undefined
  @Prop({}) public linkExport
  @Prop({}) public isDisabledExport

  @Watch('onClearFilter')
  public changeHasFilter(value: boolean, oldValue: boolean) {
    this.position = ''
    this.salescode = ''
    this.filecode = ''
    this.filterDate = []
  }

  // enable button filter
  public get enableButtonFilter() {
    if (
      (this.position.length === 0 &&
        this.salescode.length === 0 &&
        this.filecode.length === 0 &&
        (this.filterDate.length > 0 ? this.filterDate.every(e => Boolean(e) === false) : true))
    ) {
      return true
    } else {
      return false
    }
  }

  // FIlter By position
  public position: string = ''

  // FIlter By Sales code
  public salescode: string = ''

  // FIlter By Filecode
  public filecode: string = ''
  public filterDate: any = []
}
